
import { Component, OnDestroy, OnInit, input, output, inject } from '@angular/core';
import {ECustomerOrganizationStatus} from '@app/shared/enums/header.enum';
import {IProductAttribute} from '@app/shared/models/product.model';
import {selectCustomerOrganizationStatus, selectCustomerRole} from '@app/shared/state/header/header.selector';
import {environment} from '@environments/environment';
import {Store} from '@ngrx/store';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {TooltipModule} from 'primeng/tooltip';
import {Subject, takeUntil, tap} from 'rxjs';

@Component({
  selector: 'app-test-selector',
  imports: [CardModule, ButtonModule, TooltipModule, TranslateModule],
  styleUrls: ['../service-card/service-card.component.scss'],
  template: `
    <button class="transparent-button" [disabled]="isManager || isOrderCreating()" (click)="onOrderTest()">
      <p-card
        data-qa="order-item"
        data-testid="orderItem"
        styleClass="service-card {{ productAttribute().id === selectedVariantId() ? 'search-variant-highlight' : '' }}"
        [attr.data-product-id]="productAttribute().id">
        <div class="card-item">
          <span>
            <ng-content />
          </span>
        </div>
      </p-card>
    </button>
  `,
})
export class TestSelectorComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);

  readonly productAttribute = input.required<IProductAttribute>();
  readonly selectedVariantId = input.required<number | null>();
  readonly isOrderCreating = input.required<boolean>();
  readonly orderTest = output<number>();
  showButton = false;
  isLiteAccount = false;
  isManager = false;
  private readonly managerRoleId = Number(environment.managerRoleId);

  private readonly unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.initCustomerOrganizationStatus();
    this.initCustomerRole();
  }

  onOrderTest() {
    const productAttribute = this.productAttribute();
    if (productAttribute.id && !this.isLiteAccount && productAttribute.isActive) {
      this.orderTest.emit(productAttribute.id);
    }
  }

  private initCustomerOrganizationStatus(): void {
    this.store
      .select(selectCustomerOrganizationStatus)
      .pipe(
        takeUntil(this.unsubscribe$),
        tap(accountStatus => {
          this.setCustomerAccountStatus(accountStatus);
        })
      )
      .subscribe();
  }

  private initCustomerRole() {
    this.store
      .select(selectCustomerRole)
      .pipe(
        tap(customerRoleId => {
          if (customerRoleId && customerRoleId === this.managerRoleId) {
            this.isManager = true;
          }
        })
      )
      .subscribe();
  }

  private setCustomerAccountStatus(accountStatus: ECustomerOrganizationStatus): void {
    if (accountStatus === ECustomerOrganizationStatus.Active) {
      this.isLiteAccount = false;
    } else if (accountStatus === ECustomerOrganizationStatus.New) {
      this.isLiteAccount = true;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
